import { CONFIG } from "../config";

/**
 * Whether the front end should serve the "system is updating" page instead of the application.
 *
 * The flag lives in `public/config.json` as `MAINTENANCE_MODE`, which `src/config.ts` loads with a
 * **synchronous** request before the first render — so the decision is already made by the time
 * `src/index.tsx` renders, and no flash of the real app is possible.
 *
 * Because it is runtime config rather than a build-time constant, a deployment is switched in and
 * out of maintenance by setting `MAINTENANCE_MODE` in the container environment and restarting the
 * task (see `docker-entrypoint.sh`). No rebuild, no redeploy of the image.
 *
 * A missing or unparsable config.json means *not* in maintenance: the app should fail towards
 * being usable, and a config.json that will not load is already a hard failure of its own.
 */
export const isMaintenanceMode = (): boolean => {
	const flag = CONFIG?.MAINTENANCE_MODE;

	if (typeof flag === "string") {
		const normalized = flag.trim().toLowerCase();
		return normalized === "true" || normalized === "1";
	}

	return flag === true;
};

export default isMaintenanceMode;
